import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAiConsentStore = defineStore('ai-consent', () => {
  const hasConsent = ref(false)

  return { hasConsent }
})
